module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-03.e1567e35.png";